module.exports = __webpack_public_path__ + "img/Foto_Sonia_.b60dbd26.jpg";